// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F7U2","index":"styles_index__FWxdD"};